import { InjectionToken } from '@angular/core';
import { Partner, Stay } from '@shared/models';

export const STAY_LISTENER = new InjectionToken<StayListener>('cwt-stay-listener');

export interface StayListener {
    onPartnerActivated?(partner: Partner, stay?: Stay);
}